/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const digital_advise = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m14.563 14.241-.87-1.303V9.874c0-1.167-2.216-2.415-3.062-3.063m1.126 3.817L9.629 8.924A.76.76 0 1 0 8.554 10l2.06 2.326v1.458c0 .69.985 1.777.985 1.777m-2.718-.873H2.245a.802.802 0 0 1-.802-.802V3.24c0-.443.36-.801.802-.801h7.583a.802.802 0 0 1 .803.801v6.488m-2.188-3.79v-1.75h-1.75m1.75 0L3.193 9m.87 2.188v1.75m1.75-3.063v3.063"
    />
  </svg>
)
export default digital_advise
